import React, { useEffect, useState } from "react";
import { Button, Empty, Table } from "antd";
import { BellOutlined, MailOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import { translate, get_language } from "../../locale";
import moment from "moment";
import SendNotification from "../Modals/SendNotification";
import SendEmail from "../Modals/SendEmail";
import UserServices from "../../services/UserServices";
import { useLocation, useParams } from "react-router-dom";
import { TableHelper } from "../../helpers/TableHelper";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const InactiveUsers = ({ selectedData }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [selecteUser, setSelecteUser] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const { period } = useParams();
  const { subscription_id } = useParams();

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (selectedData !== null) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadData(data);
    }
  }, [JSON.stringify(tableParams), selectedData]);

  const loadData = async (data) => {
    setLoading(true);
    try {
      const subscriptionID = subscription_id !== undefined ? subscription_id : null;

      const response = await UserServices.getInactiveContacts(
        period,
        subscriptionID,
        null,
        data
      );
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.inactives);
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (value, record, index) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="text"
            icon={<BellOutlined />}
            size="small"
            className="border-0"
            onClick={() => {
              handleSendNotification(record.username);
            }}
          />
          <Button
            type="text"
            icon={<MailOutlined />}
            size="small"
            className="border-0"
            onClick={() => {
              handleSendEmail(record.username);
            }}
          />
        </div>
      ),
      width: 100,
    },
    {
      title: "Nombre del paciente",
      dataIndex: "name",
      key: "name",
      render: (_, record) => `${record.name} ${record.surname}`,
      sorter: { multiple: 3 },
    },
    {
      title: "Nombre de usuario",
      dataIndex: "username",
      key: "username",
      sorter: { multiple: 2 },
    },
    {
      title: "Días inactivo",
      dataIndex: "inactive_days",
      key: "inactive_days",
      sorter: { multiple: 1 },
    },
  ];

  const handleSendNotification = (username) => {
    setSelecteUser(username);
    setShowNotification(true);
  };

  const handleSendEmail = (username) => {
    setSelecteUser(username);
    setShowEmail(true);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Table
        rowKey={(i) => i.username}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <SendNotification
        patient={selecteUser}
        visible={showNotification}
        onCancel={() => setShowNotification(false)}
        onComplete={() => setShowNotification(false)}
      />
      <SendEmail
        patient={selecteUser}
        visible={showEmail}
        onCancel={() => setShowEmail(false)}
        onComplete={() => setShowEmail(false)}
      />
    </>
  );
};

export default InactiveUsers;
